import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PlanSuggestionInfo, AccountTrialStatus, AccountTierFields, AccountRoleInfo, AccountManagedByAdobe, AccountOwner, SubscriptionInfo, AccountLockingInfo, AccountPlanAndTrialInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountBillingQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountBillingQuery = { __typename?: 'Query', account?: { __typename?: 'Account', billingEmails?: Array<string> | null, companyName?: string | null, id: string, managedBy?: Types.AccountManagementTypes | null, owner?: { __typename?: 'Owner', id: string, email: string } | null, subscription: { __typename?: 'AccountSubscription', id: string, cancelledAt?: string | null, cost?: number | null, nextBillAt?: string | null, period: Types.SubscriptionPeriod, subscriptionEndAt?: string | null, title: string, tier: Types.AccountTier, discountOfferExpiresAt?: string | null, paymentMethod?: { __typename: 'PaymentCard' } | { __typename: 'PaymentCheck' } | null, plan?: { __typename?: 'Plan', id: string, paymentMethod: Types.PlanPaymentMethod, userLimit?: number | null, cost: number, name?: string | null, period: Types.PlanPeriod, tier: Types.PlanTier, version?: number | null } | null, trial: { __typename?: 'SubscriptionTrial', isActive: boolean, promotionExpiresAt?: string | null } }, role?: { __typename?: 'Role', id: string, name: string } | null } | null };


export const GetAccountBilling = /*#__PURE__*/ gql`
    query GetAccountBilling($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountPlanAndTrialInfo
    ...AccountRoleInfo
    billingEmails
    companyName
    id
    managedBy
    owner {
      id
      email
    }
    subscription {
      id
      cancelledAt
      cost
      nextBillAt
      paymentMethod {
        ... on PaymentCard {
          __typename
        }
        ... on PaymentCheck {
          __typename
        }
      }
      period
      plan {
        id
        paymentMethod
        userLimit
      }
      subscriptionEndAt
      title
      tier
      trial {
        isActive
        promotionExpiresAt
      }
    }
  }
}
    ${AccountPlanAndTrialInfo}
${AccountRoleInfo}` as unknown as DocumentNode<GetAccountBillingQuery, GetAccountBillingQueryVariables>;

          

          export const useGetAccountBillingQuery = (options?:QueryHookOptions<GetAccountBillingQuery, GetAccountBillingQueryVariables>) => useQuery(GetAccountBilling, options);

          

          export type GetAccountBillingQueryOptions = QueryHookOptions<GetAccountBillingQuery, GetAccountBillingQueryVariables>;

          

          export const useGetAccountBillingLazyQuery = (options?:LazyQueryHookOptions<GetAccountBillingQuery, GetAccountBillingQueryVariables>) => useLazyQuery(GetAccountBilling, options);

          

          export type GetAccountBillingQueryResult = ReturnType<typeof useGetAccountBillingQuery>;

          
